// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"12e04c0d","436":"05ecef14","453":"f394a27d","501":"d2ec42e3","606":"8ec8468d","925":"f6d6794d"}[chunkId] + ".chunk.js";
};